import _ from 'lodash';

import { APIClient } from './APIClient';
import TokenStore from '../stores/TokenStore';

//Re-export the errors to make it easy to import
export { RequestError, ServerError, BadRequestError, UnauthorisedError, NotFoundError } from '../errors/API';

class AuthenticatedAPIClient extends APIClient {

    additionalHeaders = {};

    getHeaders () {
        return Object.assign({}, super.getHeaders(), _.pickBy({
            'x-customer-token': TokenStore.getCustomer(),
            'x-customer-device': TokenStore.getDevice(),
            ...this.additionalHeaders
        }, _.isString));
    }

    setAdditionalHeaders(headers) {
        this.additionalHeaders = headers;
    }

}


export default new AuthenticatedAPIClient();
